import { RootState } from '..';

export const DeliveryDetail = (state: RootState) => state.delivery;
